<template>
  <div class="business">
    <div class="banner-box" id="home" ref="home">
      <menuBox :step="3"></menuBox>
      <div class="banner-flex-box">
        <div class="banner-text">
          <div class="title">Política de privacidad</div>
          <div class="text">
            HappyCredito atiende a usuarios colombianos y múltiples instituciones financieras, sirviendo como vínculo
            entre usuarios e instituciones para ayudar a ambas partes a lograr una situación en la que todos ganen.
            Vea la política de privacidad para obtener más información sobre HappyCredito.
          </div>
        </div>
        <img src="../assets/banner-3-item.png" alt="">
      </div>
    </div>


    <div class="privacy-title">Política De Privacidad</div>
    <select v-model="type" @change="changeType()">
      <option value="PE">Peru</option>
      <option value="CL">Chile</option>
    </select>
    <div class="privacyBox" v-if="type == 'PE'">
      Bienvenido a Happy Credito (en adelante, "nosotros" o "esta aplicación"). Como plataforma financiera
      profesional, Happy Credito coopera con varias instituciones financieras en Peru y se compromete a recomendar
      productos financieros seguros y confiables a los usuarios y ayudarlos a obtener préstamos de manera conveniente.

      <br> Happy Credito es desarrollado por GRUPO MORALES CUEVA S.A. A partir de 2024, GRUPO MORALES CUEVA S.A. prevé
      ampliar su negocio online en Internet, abarcando la atención a las industrias financieras, y apuesta por la
      creación de mayor valor para la sociedad.

      <br> Hemos desarrollado esta política de privacidad porque sabemos que a usted le preocupa cómo se recopila y
      utiliza
      su información personal, y su confianza nos honra, por lo que nos comprometemos a manejar sus datos con cuidado.
      Esta política de privacidad detalla cómo recopilamos y procesamos su información personal en nuestros
      dispositivos, productos, servicios y plataformas en línea. Si necesita instrucciones especiales, obtendremos la
      siguiente información durante el uso de esta aplicación solo con su consentimiento explícito. Lea atentamente la
      información que obtendremos.

      <h3>I. Contenido de la información que obtendremos:</h3>
      <h3>1. Información de identificación personal:</h3>
      Cuando se registra para utilizar nuestra APLICACIÓN Happy Credito, para
      garantizar la autenticidad y confiabilidad de la información recopilada, necesitamos obtener el nombre del
      usuario, número de identificación, número de teléfono, información laboral, dirección residencial y otra
      información clave para poder realizar operación necesaria. Verificar y confirmar. Al mismo tiempo, esta
      información crítica también se utilizará para proteger los derechos y la seguridad de los usuarios y prevenir
      posibles fraudes y abusos de identidad. Cumpliremos estrictamente con las leyes, regulaciones y políticas de
      privacidad pertinentes, protegeremos y administraremos la información personal de los usuarios y garantizaremos la
      seguridad y confidencialidad de la información. Prometemos utilizar esta información crítica solo cuando sea
      necesario y no revelarla a terceros no autorizados. Tomaremos medidas técnicas y administrativas razonables para
      evitar la divulgación, el mal uso y los daños de la información.
      <h3>2. Información de la lista de contactos:</h3>
      cuando utiliza la solicitud de préstamo Happy Credito para solicitar un
      préstamo, para que podamos confirmar su identidad y evaluar los riesgos, el préstamo Happy Credito debe
      seleccionar la información de la lista de contactos de emergencia (que incluye: número de contacto, nombre de
      contacto, contacto relaciones personales) para prevenir el riesgo de fraude, así como confirmar su calificación
      crediticia y garantizar una comunicación fluida. Protegeremos estrictamente su privacidad y seguridad. Los datos
      recopilados se cargarán de forma segura en el centro de seguridad
      https://eedape.friendindeedandneed.com/lucky-service/ para su almacenamiento cifrado y nunca se utilizarán para
      ningún otro propósito que no sea la recomendación de productos de préstamo. Happy Credito no puede acceder a su
      lista de contactos y solo puede obtener la información de contacto de emergencia que usted seleccionó.
      <h3>3.GAID:</h3>
      Happy Credito necesita obtener su ID de identificador de publicidad de Google para realizar el seguimiento
      de anuncios y optimizar las recomendaciones de productos financieros.
      <h3>4. Información del equipo:</h3>
      cuando utiliza los servicios de préstamo de aplicaciones de Happy Credito, para poder
      brindarle un mejor servicio, necesitamos recopilar cierta información de hardware y software. Esta información
      incluye tipo de navegador, tipo de dispositivo, sistema operativo, versión de software, modelo de hardware,
      información de red móvil y nombre de dominio utilizado para acceder al servicio, etc. Nuestro propósito al
      recopilar esta información es optimizar y mejorar nuestros servicios para satisfacer mejor sus necesidades.
      Garantizar su privacidad y la seguridad de sus datos sigue siendo nuestra principal prioridad y tomaremos las
      medidas de seguridad necesarias para proteger su información personal. Al mismo tiempo, nos comprometemos a
      utilizar esta información únicamente con su consentimiento y no utilizarla para ningún otro propósito.
      <h3>5. Permisos de cámara:</h3>
      cuando utiliza Happy Credito para solicitar servicios financieros de préstamos, para poder
      brindarle un mejor servicio, necesitamos obtener permisos de cámara en su dispositivo. Por ejemplo, algunas
      funciones requieren el uso de cámaras para tomar fotografías y reconocimiento facial para confirmar su identidad.
      Estamos comprometidos a proteger su privacidad y seguridad fotográfica y nunca usaremos indebidamente su
      información personal.
      <h3>6.Información de la cuenta social:</h3>
      cuando los usuarios usan Happy Credito, necesitamos recopilar información
      relacionada con las cuentas sociales de los usuarios para conectarnos mejor con los usuarios. Los datos
      recopilados se cargarán de forma segura en el centro de seguridad
      https://eedape.friendindeedandneed.com/lucky-service/ para su almacenamiento cifrado y nunca se divulgarán sin
      permiso.
      <h3>7. Información financiera: </h3>
      Para evaluar su puntaje crediticio, necesitamos recopilar datos sobre su situación
      financiera. Esta información puede incluir, entre otros, ingresos, gastos, deudas, activos, números de tarjetas
      bancarias, etc. Esta información puede ayudarnos a evaluar con mayor precisión el estado y el riesgo crediticio
      del usuario y garantizar la emisión de préstamos segura, confiable y precisa.
      <h3>8. Información de ubicación:</h3>
      cuando utilice nuestros servicios, obtendremos su información de ubicación aproximada
      para confirmar si es consistente con su ubicación de trabajo, a fin de brindarle mejores servicios de ubicación y
      una experiencia personalizada para satisfacer sus necesidades. Por supuesto, obtendremos su consentimiento
      explícito antes de obtener esta información.
      <h3> 9. Información de la imagen:</h3>
      cuando utiliza la función de contacto con el servicio de atención al cliente, si
      necesita cargar una imagen, obtendremos la información de la imagen que seleccionó para garantizar que su imagen
      se pueda cargar normalmente y los datos de la imagen que cargue se cargarán de forma segura. a
      https://eedape.friendindeedandneed.com/lucky-service/Almacenamiento cifrado en el Centro de seguridad y nunca se
      divulgará sin permiso.Happy Credito no puede acceder a su álbum de fotos y solo puede obtener información sobre
      las imágenes que seleccionó.
      <h3>II. Uso de la información</h3>
      <h3>1. Servicio personalizado:</h3>
      Utilizamos su información personal para establecer y mantener cuentas con el fin de proporcionar servicios y
      funciones personalizados. Esto puede incluir recomendarle contenido, productos o eventos específicos según sus
      preferencias.
      <h3>2. Envío de notificaciones:</h3>


      <br> Podemos utilizar sus datos de contacto para enviarle actualizaciones, promociones y notificaciones de la
      aplicación. Puede optar por no recibir estas notificaciones en cualquier momento.
      <h3>3. Optimización de aplicaciones:</h3>

      <br> Utilizamos información no personal para analizar el comportamiento y las preferencias del usuario para
      mejorar el
      rendimiento de la aplicación y la experiencia del usuario. Estos datos nos ayudan a comprender qué funciones son
      populares y cuáles necesitan mejorar.


      <h3>III. Almacenamiento y protección de la información</h3>


      <br> Usted tiene control sobre la información que comparte con nosotros dentro de la Aplicación, pero en
      determinadas
      circunstancias es posible que necesitemos información específica para brindar nuestros servicios. Puede
      administrar sus preferencias personales a través de la aplicación o la configuración del dispositivo móvil. Si ya
      no necesita la aplicación, puede desinstalarla completamente en cualquier momento, borrando todos los datos y
      configuraciones asociados. Tenga en cuenta que cierta información puede ser necesaria para proporcionar el
      servicio y, por lo tanto, no se puede evitar simplemente cambiando la configuración o desinstalando la aplicación.
      Si necesita más orientación o tiene otras preguntas, no dude en contactarnos (información de contacto:
      cliente@grupomoralescueva.com/in-APP atención al cliente en línea) y haremos todo lo posible para brindarle
      soporte.


      <h3>IV. Transferencia de datos personales</h3>


      <br> Utilizamos la información que tenemos sobre usted para proporcionar, personalizar y mejorar nuestros
      servicios
      combinando y aplicando datos obtenidos interna y externamente. Esto incluye comprender cómo utiliza los Servicios
      y con quién o con qué interactúa y se comunica. Prometemos nunca compartir, alquilar o vender su información
      personal de ninguna manera ilegal.


      <h3>V. Intercambio de información</h3>


      <br> Cuando visite páginas web creadas por terceros a través de nuestra plataforma, comprenda que estos terceros
      pueden
      utilizar sus propias cookies para recopilar su información. Aunque están fuera de nuestro control, estas acciones
      están sujetas a nuestras políticas y están sujetas a las políticas de protección de información personal de
      terceros. Le recomendamos leer atentamente las políticas de protección de información personal de los servicios de
      terceros antes de utilizarlos. Cumplimos con las obligaciones de revisión necesarias y nos esforzamos por exigir a
      terceros que tomen medidas para proteger su información personal. Esto ayuda a garantizar que su información
      personal esté protegida adecuadamente cuando interactúa con terceros.

      <h3>VI. Cookies</h3>

      <br> Cuando utiliza nuestros servicios, para garantizar el funcionamiento normal del sitio web, almacenaremos
      pequeños
      archivos de datos llamados cookies en su dispositivo. Normalmente, las cookies contienen un identificador, un
      nombre de sitio y algunos números y caracteres. La función principal de las cookies es mejorar su experiencia al
      utilizar los servicios de productos de préstamos Happy Credito y permitirle configurar opciones de servicio
      específicas. Cuando utiliza los servicios de productos de préstamos Happy Credito, enviaremos cookies a su
      dispositivo. Al mismo tiempo, también permitiremos que se envíen cookies a nuestro servidor cuando interactúe con
      los servicios proporcionados por nuestros socios. Prometemos no utilizar cookies para ningún otro propósito que no
      sea el de esta política. Puede gestionar o eliminar las cookies según sus preferencias personales. La mayoría de
      los navegadores web ofrecen la opción de bloquear las cookies, pero si elige hacerlo, es posible que deba cambiar
      manualmente su configuración cada vez que visite nuestro sitio web. Tenga en cuenta que esto puede afectar su
      inicio de sesión o el uso de los servicios o funciones proporcionados por los productos de préstamo Happy Credito
      que dependen de cookies.

      <h3>VII. Proveedor de servicios</h3>


      <br> Estamos muy agradecidos por su interés en Mr. Happy Credito Loans, el desarrollador de los productos de
      préstamos
      Happy Credito. Entendemos profundamente la importancia que usted otorga a la privacidad y la seguridad de los
      datos, y nos comprometemos a tomar una serie de medidas para proteger su información personal y garantizar una
      experiencia segura y cómoda al utilizar los productos de préstamos Happy Credito. Como desarrollador, nuestro
      equipo siempre cumple con las leyes y regulaciones de privacidad aplicables y toma medidas de seguridad razonables
      para proteger su información personal. Nos comprometemos a garantizar la confidencialidad, integridad y
      disponibilidad de la información y a emplear medidas técnicas y organizativas para evitar el acceso no autorizado,
      la divulgación, el uso, la modificación o el daño a su información.

      <h3>VIII. Conservación y eliminación de datos</h3>


      <br> Tiene derecho a decidir qué información se comparte dentro de la aplicación, a menos que le solicitemos que
      proporcione información específica. Puede administrar sus preferencias personales a través de la aplicación o la
      configuración de su dispositivo móvil.

      <br> Si decide no utilizar más la aplicación, puede eliminarla por completo de su dispositivo móvil en cualquier
      momento. Esto borrará todos los datos y configuraciones relacionados con la aplicación.

      <br> Tenga en cuenta que cierta información puede ser necesaria para poder brindarle el Servicio y, por lo tanto,
      no se
      puede evitar el suministro de esta información necesaria cambiando la configuración o eliminando la Aplicación.
      Por lo tanto, si desea eliminar su cuenta y todos sus datos, puede seleccionar la función de eliminación de datos
      en la APLICACIÓN para solicitar la eliminación de la cuenta, o puede eliminar datos a través del enlace que le
      proporcionamos. Asegúrese de que todos sus préstamos hayan sido liquidados antes de eliminar su cuenta. Si
      necesita orientación más detallada o tiene otras preguntas, no dude en contactarnos (información de contacto:
      cliente@grupomoralescueva.com/servicio al cliente en línea In-APP). Haremos nuestro mejor esfuerzo para brindar
      apoyo.

      <h3>IX. Cambios en el aviso de política de privacidad</h3>

      Sabemos que actualizar la política de privacidad es importante para los usuarios y los interesados. Para brindar
      mejores servicios y satisfacer las necesidades de desarrollo comercial, nos reservamos el derecho de actualizar la
      política de privacidad en cualquier momento. Cuando se realice algún cambio, se lo notificaremos mediante la
      publicación de una nueva política de privacidad. Le notificaremos de manera razonable, como mensajes emergentes,
      mensajes de posición destacada en la página, notificaciones automáticas de aplicaciones o correos electrónicos,
      etc. Prometemos no reducir los derechos originales de los usuarios al actualizar nuestra política de privacidad y
      haremos todo lo posible para notificar a los usuarios de manera razonable.


      <h3>X. Contáctanos</h3>


      <br> Si tiene alguna pregunta, no dude en contactarnos a través de los siguientes métodos:

      <br>Correo electrónico: cliente@grupomoralescueva.com

      <br>Página web oficial：https://happycreditogloble.com/

      <br> Dirección: Av. Panamericana Mz. B-1 Lote 7 Urb. San Ramon

      <br> Horario Laboral: Lunes a Domingo 9:00-17:30

      <br> Valoramos su privacidad y le agradecemos por leer nuestra Política de privacidad.
    </div>


    <div class="privacyBox" v-if="type == 'CL'">

      <br> Bienvenido a Happy Credito (en adelante, "nosotros" o "esta aplicación"). Como plataforma financiera
      profesional,
      Happy Credito coopera con varias instituciones financieras en Chile y se compromete a recomendar productos
      financieros seguros y confiables a los usuarios y ayudarlos a obtener préstamos de manera conveniente.

      <br> Happy Credito es desarrollado por GRUPO MORALES CUEVA S.A. A partir de 2024, GRUPO MORALES CUEVA S.A. prevé
      ampliar su negocio online en Internet, abarcando la atención a las industrias financieras, y apuesta por la
      creación de mayor valor para la sociedad.

      <br> Hemos desarrollado esta política de privacidad porque sabemos que a usted le preocupa cómo se recopila y
      utiliza
      su información personal, y su confianza nos honra, por lo que nos comprometemos a manejar sus datos con cuidado.
      Esta política de privacidad detalla cómo recopilamos y procesamos su información personal en nuestros
      dispositivos, productos, servicios y plataformas en línea. Si necesita instrucciones especiales, obtendremos la
      siguiente información durante el uso de esta aplicación solo con su consentimiento explícito. Lea atentamente la
      información que obtendremos.


      <h3>I. Contenido de la información que obtendremos:</h3>

      <h3>1. Información de identificación personal:</h3>
      Cuando se registra para utilizar nuestra APLICACIÓN Happy Credito, para
      garantizar la autenticidad y confiabilidad de la información recopilada, necesitamos obtener el nombre del
      usuario, número de identificación, número de teléfono, información laboral, dirección residencial y otra
      información clave para poder realizar operación necesaria. Verificar y confirmar. Al mismo tiempo, esta
      información crítica también se utilizará para proteger los derechos y la seguridad de los usuarios y prevenir
      posibles fraudes y abusos de identidad. Cumpliremos estrictamente con las leyes, regulaciones y políticas de
      privacidad pertinentes, protegeremos y administraremos la información personal de los usuarios y garantizaremos la
      seguridad y confidencialidad de la información. Prometemos utilizar esta información crítica solo cuando sea
      necesario y no revelarla a terceros no autorizados. Tomaremos medidas técnicas y administrativas razonables para
      evitar la divulgación, el mal uso y los daños de la información.
      <h3>2. Información de la lista de contactos:</h3>
      cuando utiliza la solicitud de préstamo Happy Credito para solicitar un
      préstamo, para que podamos confirmar su identidad y evaluar los riesgos, el préstamo Happy Credito debe
      seleccionar la información de la lista de contactos de emergencia (que incluye: número de contacto, nombre de
      contacto, contacto relaciones personales) para prevenir el riesgo de fraude, así como confirmar su calificación
      crediticia y garantizar una comunicación fluida. Protegeremos estrictamente su privacidad y seguridad. Los datos
      recopilados se cargarán de forma segura en el centro de seguridad
      https://eedacl.friendindeedandneed.com/lucky-service/ para su almacenamiento cifrado y nunca se utilizarán para
      ningún otro propósito que no sea la recomendación de productos de préstamo. Happy Credito no puede acceder a su
      lista de contactos y solo puede obtener la información de contacto de emergencia que usted seleccionó.
      <h3>3.GAID:</h3>
      Happy Credito necesita obtener su ID de identificador de publicidad de Google para realizar el seguimiento
      de anuncios y optimizar las recomendaciones de productos financieros.
      <h3>4. Información del equipo:</h3>
      cuando utiliza los servicios de préstamo de aplicaciones de Happy Credito, para poder
      brindarle un mejor servicio, necesitamos recopilar cierta información de hardware y software. Esta información
      incluye tipo de navegador, tipo de dispositivo, sistema operativo, versión de software, modelo de hardware,
      información de red móvil y nombre de dominio utilizado para acceder al servicio, etc. Nuestro propósito al
      recopilar esta información es optimizar y mejorar nuestros servicios para satisfacer mejor sus necesidades.
      Garantizar su privacidad y la seguridad de sus datos sigue siendo nuestra principal prioridad y tomaremos las
      medidas de seguridad necesarias para proteger su información personal. Al mismo tiempo, nos comprometemos a
      utilizar esta información únicamente con su consentimiento y no utilizarla para ningún otro propósito.
      <h3>5. Permisos de cámara:</h3>
      cuando utiliza Happy Credito para solicitar servicios financieros de préstamos, para poder
      brindarle un mejor servicio, necesitamos obtener permisos de cámara en su dispositivo. Por ejemplo, algunas
      funciones requieren el uso de cámaras para tomar fotografías y reconocimiento facial para confirmar su identidad.
      Estamos comprometidos a proteger su privacidad y seguridad fotográfica y nunca usaremos indebidamente su
      información personal.
      <h3>6.Información de la cuenta social:</h3>
      cuando los usuarios usan Happy Credito, necesitamos recopilar información
      relacionada con las cuentas sociales de los usuarios para conectarnos mejor con los usuarios. Los datos
      recopilados se cargarán de forma segura en el centro de seguridad
      https://eedacl.friendindeedandneed.com/lucky-service/ para su almacenamiento cifrado y nunca se divulgarán sin
      permiso.
      <h3>7. Información financiera: </h3>
      Para evaluar su puntaje crediticio, necesitamos recopilar datos sobre su situación
      financiera. Esta información puede incluir, entre otros, ingresos, gastos, deudas, activos, números de tarjetas
      bancarias, etc. Esta información puede ayudarnos a evaluar con mayor precisión el estado y el riesgo crediticio
      del usuario y garantizar la emisión de préstamos segura, confiable y precisa.
      <h3>8. Información de ubicación:</h3>
      cuando utilice nuestros servicios, obtendremos su información de ubicación aproximada
      para confirmar si es consistente con su ubicación de trabajo, a fin de brindarle mejores servicios de ubicación y
      una experiencia personalizada para satisfacer sus necesidades. Por supuesto, obtendremos su consentimiento
      explícito antes de obtener esta información.
      <h3>9. Información de la imagen:</h3>
      cuando utiliza la función de contacto con el servicio de atención al cliente, si
      necesita cargar una imagen, obtendremos la información de la imagen que seleccionó para garantizar que su imagen
      se pueda cargar normalmente y los datos de la imagen que cargue se cargarán de forma segura. a
      https://eedacl.friendindeedandneed.com/lucky-service/Almacenamiento cifrado en el Centro de seguridad y nunca se
      divulgará sin permiso.Happy Credito no puede acceder a su álbum de fotos y solo puede obtener información sobre
      las imágenes que seleccionó.


      <h3>II. Uso de la información</h3>

      <h3>1. Servicio personalizado:</h3>


      Utilizamos su información personal para establecer y mantener cuentas con el fin de proporcionar servicios y
      funciones personalizados. Esto puede incluir recomendarle contenido, productos o eventos específicos según sus
      preferencias.
      <h3>2. Envío de notificaciones:</h3>


      Podemos utilizar sus datos de contacto para enviarle actualizaciones, promociones y notificaciones de la
      aplicación. Puede optar por no recibir estas notificaciones en cualquier momento.
      <h3>3. Optimización de aplicaciones:</h3>


      Utilizamos información no personal para analizar el comportamiento y las preferencias del usuario para mejorar el
      rendimiento de la aplicación y la experiencia del usuario. Estos datos nos ayudan a comprender qué funciones son
      populares y cuáles necesitan mejorar.


      <h3>III. Almacenamiento y protección de la información</h3>


      Usted tiene control sobre la información que comparte con nosotros dentro de la Aplicación, pero en determinadas
      circunstancias es posible que necesitemos información específica para brindar nuestros servicios. Puede
      administrar sus preferencias personales a través de la aplicación o la configuración del dispositivo móvil. Si ya
      no necesita la aplicación, puede desinstalarla completamente en cualquier momento, borrando todos los datos y
      configuraciones asociados. Tenga en cuenta que cierta información puede ser necesaria para proporcionar el
      servicio y, por lo tanto, no se puede evitar simplemente cambiando la configuración o desinstalando la aplicación.
      Si necesita más orientación o tiene otras preguntas, no dude en contactarnos (información de contacto:
      cliente@grupomoralescueva.com/in-APP atención al cliente en línea) y haremos todo lo posible para brindarle
      soporte.


      <h3>IV. Transferencia de datos personales</h3>


      Utilizamos la información que tenemos sobre usted para proporcionar, personalizar y mejorar nuestros servicios
      combinando y aplicando datos obtenidos interna y externamente. Esto incluye comprender cómo utiliza los Servicios
      y con quién o con qué interactúa y se comunica. Prometemos nunca compartir, alquilar o vender su información
      personal de ninguna manera ilegal.


      <h3>V. Intercambio de información</h3>


      Cuando visite páginas web creadas por terceros a través de nuestra plataforma, comprenda que estos terceros pueden
      utilizar sus propias cookies para recopilar su información. Aunque están fuera de nuestro control, estas acciones
      están sujetas a nuestras políticas y están sujetas a las políticas de protección de información personal de
      terceros. Le recomendamos leer atentamente las políticas de protección de información personal de los servicios de
      terceros antes de utilizarlos. Cumplimos con las obligaciones de revisión necesarias y nos esforzamos por exigir a
      terceros que tomen medidas para proteger su información personal. Esto ayuda a garantizar que su información
      personal esté protegida adecuadamente cuando interactúa con terceros.


      <h3>VI. Cookies</h3>


      Cuando utiliza nuestros servicios, para garantizar el funcionamiento normal del sitio web, almacenaremos pequeños
      archivos de datos llamados cookies en su dispositivo. Normalmente, las cookies contienen un identificador, un
      nombre de sitio y algunos números y caracteres. La función principal de las cookies es mejorar su experiencia al
      utilizar los servicios de productos de préstamos Happy Credito y permitirle configurar opciones de servicio
      específicas. Cuando utiliza los servicios de productos de préstamos Happy Credito, enviaremos cookies a su
      dispositivo. Al mismo tiempo, también permitiremos que se envíen cookies a nuestro servidor cuando interactúe con
      los servicios proporcionados por nuestros socios. Prometemos no utilizar cookies para ningún otro propósito que no
      sea el de esta política. Puede gestionar o eliminar las cookies según sus preferencias personales. La mayoría de
      los navegadores web ofrecen la opción de bloquear las cookies, pero si elige hacerlo, es posible que deba cambiar
      manualmente su configuración cada vez que visite nuestro sitio web. Tenga en cuenta que esto puede afectar su
      inicio de sesión o el uso de los servicios o funciones proporcionados por los productos de préstamo Happy Credito
      que dependen de cookies.


      <h3>VII. Proveedor de servicios</h3>


      Estamos muy agradecidos por su interés en Mr. Happy Credito Loans, el desarrollador de los productos de préstamos
      Happy Credito. Entendemos profundamente la importancia que usted otorga a la privacidad y la seguridad de los
      datos, y nos comprometemos a tomar una serie de medidas para proteger su información personal y garantizar una
      experiencia segura y cómoda al utilizar los productos de préstamos Happy Credito. Como desarrollador, nuestro
      equipo siempre cumple con las leyes y regulaciones de privacidad aplicables y toma medidas de seguridad razonables
      para proteger su información personal. Nos comprometemos a garantizar la confidencialidad, integridad y
      disponibilidad de la información y a emplear medidas técnicas y organizativas para evitar el acceso no autorizado,
      la divulgación, el uso, la modificación o el daño a su información.


      <h3>VIII. Conservación y eliminación de datos</h3>


      <br> Tiene derecho a decidir qué información se comparte dentro de la aplicación, a menos que le solicitemos que
      proporcione información específica. Puede administrar sus preferencias personales a través de la aplicación o la
      configuración de su dispositivo móvil.

      <br> Si decide no utilizar más la aplicación, puede eliminarla por completo de su dispositivo móvil en cualquier
      momento. Esto borrará todos los datos y configuraciones relacionados con la aplicación.

      <br> Tenga en cuenta que cierta información puede ser necesaria para poder brindarle el Servicio y, por lo tanto,
      no se
      puede evitar el suministro de esta información necesaria cambiando la configuración o eliminando la Aplicación.
      Por lo tanto, si desea eliminar su cuenta y todos sus datos, puede seleccionar la función de eliminación de datos
      en la APLICACIÓN para solicitar la eliminación de la cuenta, o puede eliminar datos a través del enlace que le
      proporcionamos. Asegúrese de que todos sus préstamos hayan sido liquidados antes de eliminar su cuenta. Si
      necesita orientación más detallada o tiene otras preguntas, no dude en contactarnos (información de contacto:
      cliente@grupomoralescueva.com/servicio al cliente en línea In-APP). Haremos nuestro mejor esfuerzo para brindar
      apoyo.


      <h3>IX. Cambios en el aviso de política de privacidad</h3>


      Sabemos que actualizar la política de privacidad es importante para los usuarios y los interesados. Para brindar
      mejores servicios y satisfacer las necesidades de desarrollo comercial, nos reservamos el derecho de actualizar la
      política de privacidad en cualquier momento. Cuando se realice algún cambio, se lo notificaremos mediante la
      publicación de una nueva política de privacidad. Le notificaremos de manera razonable, como mensajes emergentes,
      mensajes de posición destacada en la página, notificaciones automáticas de aplicaciones o correos electrónicos,
      etc. Prometemos no reducir los derechos originales de los usuarios al actualizar nuestra política de privacidad y
      haremos todo lo posible para notificar a los usuarios de manera razonable.


      <h3>X. Contáctanos</h3>


      <br> Si tiene alguna pregunta, no dude en contactarnos a través de los siguientes métodos:

      <br> Correo electrónico: cliente@grupomoralescueva.com

      <br> Página web oficial：https://happycreditogloble.com/

      <br>Dirección: Av. Panamericana Mz. B-1 Lote 7 Urb. San Ramon

      <br> Horario Laboral: Lunes a Domingo 9:00-17:30

      <br> Valoramos su privacidad y le agradecemos por leer nuestra Política de privacidad.
    </div>

    <!-- <div class="list-box">
      <div class="item">
        <img src="../assets/imglist-1.png" alt="">
        <p>Batido de arándanos</p>
      </div>
      <div class="item">
        <img src="../assets/imglist-2.png" alt="">
        <p>Jugo de macaco</p>
      </div>
      <div class="item">
        <img src="../assets/imglist-3.png" alt="">
        <p>Técnica leche de jazmín</p>
      </div>
      <div class="item">
        <img src="../assets/imglist-4.png" alt="">
        <p>Arroz de cazuela de barro</p>
      </div>
      <div class="item">
        <img src="../assets/imglist-5.png" alt="">
        <p>Pollo asado especial</p>
      </div>
      <div class="item">
        <img src="../assets/imglist-6.png" alt="">
        <p>Parrilla española</p>
      </div>
    </div>
    <div class="img-box">
      <img src="../assets/imglist-big.png" alt="">
    </div>
    <div class="list-box">
      <div class="item">
        <img src="../assets/imglist-7.png" alt="">
        <p>Batido de fresa</p>
      </div>
      <div class="item">
        <img src="../assets/imglist-8.png" alt="">
        <p>Malteada de chocolate</p>
      </div>
      <div class="item">
        <img src="../assets/imglist-9.png" alt="">
        <p>Batido de taro</p>
      </div>
      <div class="item">
        <img src="../assets/imglist-10.png" alt="">
        <p>Bife</p>
      </div>
      <div class="item">
        <img src="../assets/imglist-11.png" alt="">
        <p>Tom Yum Kung tailandés</p>
      </div>
      <div class="item">
        <img src="../assets/imglist-12.png" alt="">
        <p>Paquete para perder grasa</p>
      </div>
    </div> -->

    <!-- <div class="del-data-box">
      <img src="../assets/delete.png" class="delete-img">
      <div class="tel-box" v-if="steps == 1">
        <div class="tip">Al utilizar la función de eliminación de datos, para proteger su información, necesitará verificar su identidad.</div>
        <div class="title">Por favor, ingrese su número de teléfono móvil.</div>
        <input v-model="mobile" type="text" class="tel-in" placeholder="Por favor, ingrese su número de teléfono móvil.">
        <input v-model="password" type="password" class="tel-pa" placeholder="Ingrese la contraseña de la aplicación.">
        <div class="btn" @click="delSearch">Siguiente</div>
      </div>
      <div class="tel-box" v-else-if="steps == 2">
        <div class="text-box">
          Estimado usuario:
          <br>¡Hola! Agradecemos sinceramente que haya elegido utilizar la aplicación .
          <br> Antes de solicitar la eliminación de su cuenta, por favor asegúrese de que todas sus órdenes estén completadas y que no haya órdenes pendientes de revisión. Tenga en cuenta que una vez que se elimine la cuenta, los datos no podrán ser recuperados. Por favor, confirme cuidadosamente antes de proceder. Esta aplicación no asume ninguna responsabilidad por pérdidas personales o financieras derivadas de esta acción.
          <br> Si confirma que desea eliminar sus datos, por favor haga clic en el botón a continuación.
        </div>
        <div class="btn" @click="candelete">Confirmar eliminación</div>
      </div>
      <div class="tel-box" v-else-if="steps == 3">
        <div class="title">Por favor, ingrese el código de verificación para verificar su identidad.</div>
        <div class="iump-box">
          <input v-model="code" type="text" class="car-in tel-in" placeholder="Ingrese el código de 4 dígitos.">
          <div class="count-btn" @click="Reenviar"> {{ Time > 0 ? Time : 'Obtener código de verificación' }} </div>
        </div>
        <div class="btn" @click="doDelete">Eliminar</div>
      </div>
      <div class="tel-box del-box" v-else-if="steps == 4">
        <img src="../assets/del.png" alt="">
        <p>¡Sus datos han sido eliminados!</p>
      </div>
      <div class="tel-box" v-else-if="steps == 5">
        <div class="title">Verificar identidad</div>
        <input v-model="idcard" type="text" class="tel-in" placeholder="Por favor, ingrese su número de identificación.">
        <div class="btn" @click="verifyIdCard">Confirmar</div>
      </div>
    </div> -->

    <!-- <div class="flex-box" v-if="msgDlg">
      <div class="msg-box">
        <div class="msg">
          <img src="../assets/title-err.png" class="err-img">
          {{ msg }}
        </div>
        <img src="../assets/close.png" class="close" @click="msgDlg = false">
      </div>
    </div> -->

    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
import * as api from "@/api/api";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      mobile: '',
      password: '',
      code: '',
      msgDlg: false,
      msg: '',
      steps: 1,
      infoData: {},
      Time: 0,
      idcard: '',
      verifyIDCard: '',
      type: 'PE'
    };
  },
  mounted() { },
  methods: {
    changeType() {
      console.log(this.type);
    },
    aboutUs() {
      this.$router.push({ path: "aboutUs" });
    },
    submit() {
      alert("Success");
    },

    delSearch() {
      let data = {
        mobile: this.mobile,
        password: this.password
      }
      console.log(this.$loading);
      let loding = this.$loading.show({})
      api.delInfoSearch(data).then(res => {
        loding.hide()
        this.infoData = res.data
        this.steps = 2
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    candelete() {
      let data = {
        user_id: this.infoData.user_id
      }
      let loding = this.$loading.show({})
      api.delInfoCanDelete(data).then(res => {
        loding.hide()
        if (res.data.idcard) {
          this.verifyIDCard = res.data.idcard
          this.steps = 5
        } else {
          this.steps = 3
          this.Reenviar()
        }
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    verifyIdCard() {
      console.log(this.verifyIDCard);
      if (this.verifyIDCard == this.idcard) {
        this.steps = 3
        this.Reenviar()
      } else {
        this.msgDlg = true
        this.msg = 'La tarjeta de identificación se ingresó incorrectamente y la verificación falló.'
      }
    },
    Reenviar() {
      if (this.Time > 0) {
        return
      }
      this.Countdown(60)
      let data = {
        mobile: this.mobile
      }
      let loding = this.$loading.show({})
      api.delInfoSms(data).then(res => {
        loding.hide()
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    doDelete() {
      if (!this.code) {
        this.msgDlg = true
        this.msg = 'Se debe completar el código de verificación.'
        return
      }
      let loding = this.$loading.show({})
      let data = {
        mobile: this.mobile,
        code: this.code,
        user_id: this.infoData.user_id
      }
      api.delInfoDoDelete(data).then(res => {
        loding.hide()
        this.steps = 4
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    Countdown(time) {
      this.Time = time
      if (time <= 0) {
        return
      }

      setTimeout(() => {
        this.Countdown(time - 1)
      }, 1000);
    }
  },
};
</script>
<style lang="less" scoped>
select {
  margin-left: 360px;
}

.banner-box {
  background-image: url(../assets/swiper-3.png);
  height: 750px;
  background-size: 100% 100%;

  .banner-flex-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 130px;

    .banner-text {
      text-align: left;
      width: 800px;
      margin-left: 160px;
      margin-right: 58px;

      .title {
        font-family: Baskerville, Baskerville;
        font-weight: bold;
        font-size: 80px;
        color: #FFFFFF;
      }


      .text {
        font-family: Baskerville;
        font-size: 28px;
        color: #FFFFFF;
        margin-top: 20px;
      }
    }

    img {
      width: 600px;
      margin-right: 360px;
    }
  }

}

.privacy-title {
  font-weight: bold;
  font-size: 48px;
  color: #333333;
  text-align: center;
  margin-top: 120px;
}

.privacyBox {
  margin: 100px 360px;
  height: 1000px;
  background: #FBF0CE;
  border-radius: 10px;
  border: 1px solid #EAB308;
  padding: 60px;
  overflow-y: scroll;
  font-size: 22px;
  color: #333333;
}

// .list-box {
//   padding: 120px 360px;
//   display: flex;
//   align-items: flex-start;
//   justify-content: space-between;
//   flex-wrap: wrap;

//   .item {
//     margin-bottom: 60px;

//     img {
//       width: 380px;
//       height: 268px;
//     }

//     p {
//       font-family: Baskerville, Baskerville;
//       font-weight: bold;
//       font-size: 32px;
//       color: #333333;
//       padding-left: 20px;
//       width: 360px;

//     }
//   }
// }

.img-box {
  padding: 0 360px;
  margin-top: -60px;

  img {
    width: 100%;
  }
}

.del-data-box {
  // background: #F5F5F5;
  padding: 100px 360px;
  display: flex;
  align-items: self-start;
  justify-content: space-between;

  .delete-img {
    width: 500px;
  }

  .tel-box {
    min-height: 155px;
    background: #FFFFFF;
    padding: 40px 150px;
    display: flex;
    flex-direction: column;
    align-items: self-start;

    .tip {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
    }

    .title {
      font-size: 24px;
      font-weight: 400;
      color: #333333;
      margin-top: 24px;
    }

    .tel-in,
    .tel-pa {
      width: 452px;
      height: 60px;
      border-radius: 5px;
      border: 1px solid #EFEFEF;
      margin-top: 14px;
      padding: 0px 24px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 60px;
    }

    .iump-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 24px;
      width: 500px;
    }

    .car-in {
      width: 302px;
      margin: 0;
    }

    .btn {
      width: 452px;
      height: 60px;
      padding: 0px 24px;
      background: #EAB308;
      border-radius: 5px;
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
      line-height: 60px;
      margin-top: 24px;
      cursor: pointer;
    }

    .count-btn {
      width: 120px;
      height: 60px;
      border-radius: 8px;
      border: 1px solid #EFEFEF;
      line-height: 60px;
      font-size: 16px;
      font-weight: 400;
      color: #EAB308;
      text-align: center;
      cursor: pointer;
    }

    .text-box {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
    }
  }

  .del-box {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    img {
      width: 97px;
    }

    p {
      font-size: 16px;
      font-weight: 400;
      margin-top: 24px;
    }
  }
}

.flex-box {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background: fade(#000, 90%);
  display: flex;
  align-items: center;
  justify-content: center;

  .msg-box {
    position: relative;

    .err-img {
      width: 100px;
      margin-top: -100px;
    }

    .msg {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      background: #fff;
      text-align: center;
      color: #999;
      font-size: 26px;
      padding: 50px;
      width: 380px;
      border-radius: 17px;

    }

    .close {
      position: absolute;
      right: 10px;
      top: 10px;
      width: 30px;
    }
  }
}
</style>